require('dayjs/locale/ko');
window.$ = window.jQuery = require('jquery');
window._ = require('lodash');
window.toastr = require('toastr');
window.Cookies = require('js-cookie');
window.Swal = require('sweetalert2');
window.dayjs = require('dayjs');
window.dayjs.locale('ko');
window.dayjs.extend(require('dayjs/plugin/isBetween'));
window.dayjs.extend(require('dayjs/plugin/utc.js'));
window.dayjs.extend(require('dayjs/plugin/timezone'));
window.dayjs.extend(require('dayjs/plugin/isSameOrAfter'));
window.dayjs.extend(require('dayjs/plugin/isSameOrBefore'));
window.dayjs.tz.setDefault("Asia/Seoul");

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// window.axios = require('axios');
//
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */


// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
